import { type FunctionComponent } from 'react';
import { Splash } from '../../components/Splash/Splash';
import { DATA_LOADING_TIMEOUT } from '../../constants';

export type SplashPageProps = {
  timeoutMs?: number;
};

export const SplashPage: FunctionComponent<SplashPageProps> = ({
  timeoutMs = DATA_LOADING_TIMEOUT,
}) => {
  // TODO: Import useTitle hook
  // useTitle('splash');

  return (
    <div>
      <Splash timeoutMs={timeoutMs} />
    </div>
  );
};
